<template>
  <div class="py-10 pb-md-0 pt-md-13 pt-lg-16">
    <TitleWidget class="text-center"> Parceiros </TitleWidget>

    <LoadingWidget v-if="loading" class="py-0 py-md-13 py-lg-16" />

    <transition name="fade">
      <div v-if="!loading && items.length">
        <div
          :class="{ 'mt-10': keyItems == 0 || smAndDown }"
          v-for="(item, keyItems) in items"
          :key="keyItems"
        >
          <PartnerCard v-bind="item" :left="keyItems % 2 == 0" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { formatToURL } from "../utils/formatToURL";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import PartnerCard from "../components/cards/PartnerCard.vue";

const _config = {
  mod: "partners",
  path: "/parceiros",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    itemsPerPage: 100,
    items: [],
  }),
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({
          params: {
            itemsPerPage: this.itemsPerPage,
          },
        })
        .then((data) => {
          this.items = data.map(
            ({ id, img_brand, img, title, introduction }) => ({
              img_brand,
              img,
              title,
              introduction,
              to: `${this.path}/${formatToURL(title)}-${id}`,
            })
          );
        })
        .then(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.get();
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    PartnerCard,
  },
};
</script>
